import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ children, adminOnly = false, clientOnly = false }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return null;

  if (!user) {
    const redirect = encodeURIComponent(`${location.pathname}${location.search}`);
    return <Navigate to={`/login?redirect=${redirect}`} replace />;
  }

  if (adminOnly && !["admin", "subadmin"].includes(user.role)) return <Navigate to="/account" replace />;
  if (clientOnly && user.role !== "client") return <Navigate to="/admin" replace />;

  return children;
};
